export var lassoTitles = [
	'Rodeo<br/>Architects',
	'Landscape',
	'Architecture',
	'Urbanism',
	'Studio',
	'Social Science',
		]